import React from 'react';

import {Column} from 'react-table';

import {
    ColumnExtendedProps,
    GridFieldConfig,
    InnerFilters,
    InnerFiltersElement,
    InnerSortings,
    InnerSortingsElement,
} from '@shared/types/grid';

import {HeaderWrapper} from './HeaderWrapper';

export function mapTableColumns(
    columns: GridFieldConfig[],
    filters?: InnerFilters,
    filtersChanged?: (value: InnerFiltersElement[]) => void,
    filtersReset?: (value: string[]) => void,
    sortings?: InnerSortings,
    sortingsChanged?: (value: InnerSortingsElement[]) => void,
): Array<Column<object> & ColumnExtendedProps> {
    return columns.map((elem) => {
        const result: Column<object> & ColumnExtendedProps = {
            accessor: elem.id,
            Header: (
                <HeaderWrapper
                    header={elem.header}
                    hideHeader={elem.hideHeader}
                    filterComponent={elem.filter}
                    filterValue={filters && filters[elem.id]}
                    onFilterChange={
                        filtersChanged && ((value) => filtersChanged([{id: elem.id, value}]))
                    }
                    onFilterReset={filtersReset && (() => filtersReset([elem.id]))}
                    sortingValue={sortings && sortings[elem.id]}
                    onSortingChange={
                        elem.isSortable && sortingsChanged
                            ? (value) => sortingsChanged([{id: elem.id, value}])
                            : undefined
                    }
                />
            ),
            ignoreConfig: elem.ignoreConfig ?? false,
            columns:
                elem.columns &&
                mapTableColumns(
                    elem.columns,
                    filters,
                    filtersChanged,
                    filtersReset,
                    sortings,
                    sortingsChanged,
                ),
        };

        if (elem.width != null) {
            result.width = elem.width;
        }
        if (elem.minWidth != null) {
            result.minWidth = elem.minWidth;
        }
        if (elem.maxWidth != null) {
            result.maxWidth = elem.maxWidth;
        }

        return result;
    });
}
